import { AiEngineDataType } from "./enums";

export const AiEnginePaths = {
  [AiEngineDataType.MoreOnThisTopic]: "/recommend/next",
  [AiEngineDataType.OnBoard]: "/recommend/on-board",
  [AiEngineDataType.TopPicks]: "/recommend/top-picks",
};

export const AiFallbackPaths = {
  [AiEngineDataType.MoreOnThisTopic]: "/rec-backup/next.json",
  [AiEngineDataType.OnBoard]: "/rec-backup/on-board",
  [AiEngineDataType.TopPicks]: "/rec-backup/top-picks.json",
};
